export default "__VITE_ASSET__866cf946__"